import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useTelegramBackButton = () => {
	const location = useLocation();

	useEffect(() => {
		if (location.pathname === "/") return;
		
		const tg = window.Telegram?.WebApp;
		tg?.BackButton?.show();

		const handleClick = () => {
			window.history.back();
		};

		tg?.BackButton?.onClick(handleClick);

		return () => {
			tg?.BackButton?.hide();
			tg?.BackButton?.offClick(handleClick);
		};
	}, [location]);
};
